import React, { useEffect, useState } from 'react';
import {
    Dialog,
    Box,
    Typography,
    Button,
    IconButton,
    Stack,
    Divider,
    Grid,
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import get from "lodash/get";
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';

import InputText from "../../../../components/form/InputText";
import InputTextPass from "../../../../components/form/InputTextPass";
import Switch from "../../../../components/form/Switch";
import DatePickerUi from "../../../../components/form/DatePickerUi";
import ChangePass from "./ChangePass";
import validatorDriver from "./validatorDriver"
import FilesModal from './FilesModal';
import Alert from "../../../../components/form/Alert";
import { useCanView } from "../../../../config/hook/UserPermissions";

import { postDriver} from "../../../../store/masters/thunk/driver/post";
import { putDriver } from "../../../../store/masters/thunk/driver/put";

const DriverModal = ({
    __,
    open,
    close,
    selected,
    setSelected,
    reload,
    setError
}) => {

    const idDriver = Number(get(selected, "idDriver", ""));
    const dispatch = useDispatch();
    const [openChangePass, setOpenChangePass] = useState(false);
    const [showGalery, setShowGalery] = useState(false);
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
    const canView = useCanView();

    const closeChangePass = () => {
        setOpenChangePass(false)
    }

    const current = selected
    const put = useSelector(state => state.masters.driver.put);
    const post = useSelector(state => state.masters.driver.post);
    const currentProvider = useSelector((state) => state.masters.provider.detail);
    const user = useSelector(state => state.auth.login.dataUser);

    const onCloseModal = (r) => {
        setSelected({})
        close()
        if (r === "1") {
            reload()
        }
    }

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    useEffect(() => {
        if (get(post, "isSuccess", false)) { onCloseModal("1") }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post"); close() }
        if (get(put, "isSuccess", false)) { onCloseModal("1") }
        if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put"); close() }
    }, [post, put])

    const idProvider = Number(get(currentProvider, "data.id"));
   
    const onSubmit = (values) => {   
        if (canView("MAESTROS/PROVEEDORES/CONDUCTORES", "update")) {
            if (idDriver) { 
                const body = {
                    idDriver: idDriver,
                    idProvider: idProvider,
                    name: String(get(values, "name", "")),
                    license: String(get(values, "license")),
                    dateExpire: get(values, "dateExpire"),
                    isActive: Boolean(get(values, "isActive", true)),
                    email: String(get(values, "email")),
                    password: String(get(values, "pass")),
                    phone: String(get(values, "phone")),
                }
                dispatch(putDriver(body)) 
            } else {
                const body = {
                    idProvider: idProvider,
                    name: String(get(values, "name", "")),
                    license: String(get(values, "license")),
                    dateExpire: get(values, "dateExpire"),
                    isActive: Boolean(get(values, "isActive", true)),
                    email: String(get(values, "email")),
                    password: String(get(values, "pass")),
                    phone: String(get(values, "phone")),
                }
                dispatch(postDriver(body)) 
            }
        } else {
            setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para actualizar el conductor del proveedor.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }

    const initialValues = {

        name: idDriver ? get(current, "name", "") : "", 
        license: idDriver ? get(current, "license", "") : "",
        dateExpire: idDriver ? get(current, "dateExpire", "") : new Date(),
        isActive: idDriver ? get(current, "price", true) : true,
        phone: idDriver ? get(current, "phone", "") : "",
        email: idDriver ? get(current, "email", "") : "",
        pass: idDriver ? get(current, "password", "") : ""
    }

    return (
        <div>
            <Dialog onClose={onCloseModal} open={open} maxWidth="lg" fullWidth>
                <Box>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1, ml: 3 }}>
                        {idDriver ? __("head.edit.name") : __("head.new.name")}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={onCloseModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <div>
                    {!open
                        ? (
                            <Box sx={{ minHeight: 200, width: "100%" }} />
                        ) : (
                            <Formik initialValues={initialValues}
                               validationSchema={validatorDriver(__, idDriver)}
                                onSubmit={onSubmit}>
                                {formik => (
                                    <form id="provider-driver-form" onSubmit={get(formik, "handleSubmit")}>
                                        <div className='relative'>
                                            <Divider />
                                            <Box className='p-4' >
                                                <Grid container spacing={{ xs: 2, md: 3 }}>
                                                    <Grid item xs={12}>
                                                        <Stack className='p-4' direction="row" spacing={2} justifyContent="flex-end">
                                                            { idDriver ? 
                                                                <Button className='w-[100px] min-w-[100px]' variant='text' color="secondary" onClick={() => {
                                                                    if (canView("MAESTROS/PROVEEDORES/CONDUCTORES/ADJUNTOS", "watch")) {
                                                                        setShowGalery(true)
                                                                    } else {
                                                                        setAlert({
                                                                            open: true,
                                                                            title: "Permiso Denegado.",
                                                                            subtitle: (<ul> • No tienes permiso para ver los adjuntos del conductor.</ul>),
                                                                            type: "error",
                                                                            btn: __(`${module}.actions.close`),
                                                                            func: closeAlert
                                                                        })
                                                                    }
                                                                }} disabled={get(put, "isLoading")} >
                                                                    <div className='whitespace-nowrap'>Ver Adjuntos</div>
                                                                </Button> : (<div></div>)
                                                            }                                   
                                                            { idDriver ? 
                                                                <Button size="small" variant="contained" color="secondary" onClick={() => {
                                                                    if (canView("MAESTROS/PROVEEDORES/CONDUCTORES/CONTRASEÑA", "update")) {
                                                                        setOpenChangePass(true)
                                                                    } else {
                                                                        setAlert({
                                                                            open: true,
                                                                            title: "Permiso Denegado.",
                                                                            subtitle: (<ul> • No tienes permiso para actualizar la contraseña del conductor.</ul>),
                                                                            type: "error",
                                                                            btn: __(`${module}.actions.close`),
                                                                            func: closeAlert
                                                                          })
                                                                    }
                                                                }} disabled={get(post, "isLoading") || get(put, "isLoading")} >{"Cambiar contraseña"}</Button> :
                                                                (<div></div>)
                                                            }
                                                            <Switch formik={formik} name="isActive" __={__} />
                                                        </Stack>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <InputText
                                                            formik={formik}
                                                            name="name"
                                                            label={__(`form.name.label`)}
                                                            placeholder={__(`form.name.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <InputText
                                                            formik={formik}
                                                            name="license"
                                                            label={__(`form.license.label`)}
                                                            placeholder={__(`form.license.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <DatePickerUi
                                                            formik={formik}
                                                            name="dateExpire"
                                                            label={__(`form.dateExpire.label`)}
                                                            placeholder={__(`form.dateExpire.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography className='pt-4' component="p" variant="bmr" color="text.lite" >{__(`labels.2`)}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <InputText
                                                            formik={formik}
                                                            name="phone"
                                                            label={__(`form.phone.label`)}
                                                            placeholder={__(`form.phone.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography className='pt-4' component="p" variant="bmr" color="text.lite" >{__(`labels.3`)}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <InputText
                                                            formik={formik}
                                                            name="email"
                                                            label={__(`form.email.label`)}
                                                            placeholder={__(`form.email.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                        />
                                                    </Grid>
                                                    {!idDriver && 
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <InputTextPass
                                                            formik={formik}
                                                            name="pass"
                                                            label={__(`form.pass.label`)}
                                                            placeholder={__(`form.pass.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                        />
                                                    </Grid>
                                                    }
                                                </Grid>
                                            </Box>
                                        </div>
                                    </form>
                                )}
                            </Formik>
                        )}
                </div>
                <Stack className='p-4' direction="row" spacing={2} justifyContent="flex-end">
                    <LoadingButton variant="contained" color="secondary" startIcon={<SaveIcon/>} type="submit" form="provider-driver-form" loading={get(post, "isLoading") || get(put, "isLoading")}>{__("action.save")}</LoadingButton>
                    <Button variant='outlined' color="secondary" onClick={onCloseModal} disabled={get(post, "isLoading") || get(put, "isLoading")} >{__(`action.cancel`)}</Button>
                </Stack>
            </Dialog>
            <ChangePass
                __={__}
                open={openChangePass}
                onClose={closeChangePass}
                current={current}
            />
            <FilesModal
                __={__}
                open={showGalery}
                selected={selected}
                close={() => setShowGalery(false)}
            />
        </div>
    );
}

export default DriverModal